import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gym-trainer',
  templateUrl: './gym-trainer.component.html',
  styleUrls: ['./gym-trainer.component.scss']
})
export class GymTrainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
